'use strict';

var styles = require('@mui/material/styles');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var palette = {
  primary: {
    main: '#415670',
    800: '#1E2E45',
    700: '#30445E',
    600: '#415670',
    500: '#506A8A',
    400: '#849CB8',
    300: '#B5C3D4',
    200: '#DAE1EA',
    100: '#EFF1F5'
  },
  secondary: {
    main: '#8A755B',
    800: '#5E4C38',
    700: '#73604A',
    600: '#8A755B',
    500: '#9E8B70',
    400: '#BDA98C',
    300: '#E0D4BF',
    200: '#EBE2D3',
    100: '#FAF7F3'
  },
  grey: {
    main: '#26201F',
    800: '#26201F',
    700: '#393432',
    600: '#4E4947',
    500: '#756F6E',
    400: '#918D8C',
    300: '#B8B6B5',
    200: '#E5E4E3',
    100: '#F3F3F3'
  },
  error: {
    main: '#B8554D',
    500: '#7A2F29',
    400: '#A33F37',
    300: '#CC4F45',
    200: '#F0BAB6',
    100: '#FAE7E6'
  },
  white: {
    main: '#FFFFFF',
    warm: '#FCFAF7',
    cold: '#FAFCFC',
    white: '#FFFFFF'
  },
  illustration: {
    main: '#415066',
    auxiliary: '#DFE5F0',
    dotted: '#F2B844'
  },
  textPrimary: {
    main: '#272727',
    white: '#FFFFFF',
    black: '#000000'
  },
  textSecondary: {
    main: 'grey',
    white: 'rgba(255, 255, 255, 0.7)',
    black: 'rgba(0, 0, 0, 0.5)'
  },
  textDisabled: {
    main: 'grey',
    white: 'rgba(255, 255, 255, 0.7)',
    black: 'rgba(0, 0, 0, 0.25)'
  },
  multicolor: {
    300: '#C79F50',
    200: '#FAE1AF',
    100: '#F7F3EB',
    yellow: {
      300: '#906716',
      200: '#CC9A39',
      100: '#CC9A39'
    },
    green: {
      300: '#008A5E',
      200: '#12B883',
      100: '#E6F3EF'
    }
  },
  opacityLayer: {
    dark: {
      400: '#FFFFFF80',
      300: '#FFFFFF59',
      200: '#FFFFFF33',
      100: '#00000026'
    },
    light: {
      400: '#00000080',
      300: '#0000004D',
      200: '#00000033',
      100: '#0000001A'
    }
  },
  shadow: '#E8E8E8'
};
palette.gray = palette.grey;
var fontFamily = 'Open Sans';
var theme = styles.createTheme({
  palette: palette,
  fontFamily: fontFamily,
  spacing: function spacing(value) {
    return value * 8;
  },
  breakpoints: {
    // which is also defined in orkaui.scss
    values: {
      xs: 0,
      sm: 600,
      // Phone-Max
      md: 905,
      // Tablet-Max
      dl: 1024,
      // Desktop-Max
      lg: 1538,
      // PC-Max
      xl: 1920
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans',
          color: palette.textPrimary.main,
          fontSize: '12px'
        },
        colorError: {
          color: palette.error.main
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: palette.primary.main,
          '&:hover': {
            color: palette.primary.main
          }
        }
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.2)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        },
        elevation1: {
          boxShadow: 'none',
          '&:before': {
            display: 'none'
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: 'FFFFFF',
          fontSize: '14px',
          fontWeight: '500',
          lineHeight: '18px',
          letterSpacing: '-0.15px',
          borderRadius: '10px'
        }
      }
    },
    MuiExpansionPanel: {
      styleOverrides: {
        root: {
          marginBottom: 16
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          marginBottom: 16
        }
      }
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          padding: '24px 0'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem'
        }
      }
    }
  }
});
theme.components.MuiTypography.styleOverrides = {
  root: {
    fontFamily: 'Open Sans',
    padding: 0,
    paddingTop: 0,
    paddingBottom: 0,
    WebkitFontSmoothing: 'antialiased',
    textAlign: 'left'
  },
  h1: _defineProperty({
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '48px',
    lineHeight: '64px',
    letterSpacing: '0.2px'
  }, theme.breakpoints.down('sm'), {
    fontSize: '40px',
    lineHeight: '52px'
  }),
  h2: _defineProperty({
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '40px',
    lineHeight: '52px',
    letterSpacing: '0'
  }, theme.breakpoints.down('sm'), {
    fontSize: '32px',
    lineHeight: '42px'
  }),
  h3: _defineProperty({
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '32px',
    lineHeight: '44px',
    letterSpacing: '0'
  }, theme.breakpoints.down('sm'), {
    fontSize: '24px',
    lineHeight: '32px'
  }),
  h4: {
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0'
  },
  T1: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '-0.4px'
  },
  T2: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.2px'
  },
  t1: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '-0.4px'
  },
  t2: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  },
  Body1: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.2px'
  },
  body1: {
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.2px'
  },
  Body2: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '-0.2px'
  },
  body2: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '-0.2px'
  },
  Body3: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.2px'
  },
  body3: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.2px'
  },
  Body4: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  },
  body4: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  },
  Body5: {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0'
  },
  body5: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0'
  },
  BUTTON: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '-0.6px'
  },
  Button: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px'
  },
  LINK: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '-0.2px',
    textDecorationLine: 'underline',
    cursor: 'pointer'
  },
  Link: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.2px',
    textDecorationLine: 'underline',
    cursor: 'pointer'
  },
  link: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px',
    textDecorationLine: 'underline',
    cursor: 'pointer'
  },
  info: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  }
}; // Typography alias

var styleOverrides = theme.components.MuiTypography.styleOverrides; // for deprecated

styleOverrides['subh1'] = styleOverrides['Body2'];
styleOverrides['subh2'] = styleOverrides['Body3'];
styleOverrides['link1'] = styleOverrides['Link'];
styleOverrides['link2'] = styleOverrides['link'];
styleOverrides['caption'] = styleOverrides['body4']; // for convinence

styleOverrides['title1'] = styleOverrides['T1'];
styleOverrides['title2'] = styleOverrides['T2'];
styleOverrides['subtitle1'] = styleOverrides['t1'];
styleOverrides['subtitle2'] = styleOverrides['t2'];
styleOverrides['botton-l'] = styleOverrides['BUTTON'];
styleOverrides['botton-m'] = styleOverrides['Button'];
styleOverrides['botton-s'] = styleOverrides['Button'];
styleOverrides['button'] = styleOverrides['Button'];
styleOverrides['link-l'] = styleOverrides['LINK'];
styleOverrides['link-m'] = styleOverrides['Link'];
styleOverrides['link-s'] = styleOverrides['link'];

module.exports = theme;
